import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { takeUntil, tap } from "rxjs/operators";

@Component({
	selector: "ic-katz-form-card",
	templateUrl: "./katz-form.component.html",
	styleUrls: ["./katz-form.component.scss"],
	standalone: false,
})
export class KATZFormComponent implements OnInit, OnDestroy {
	baseSteps = ["washing", "clothing", "transfer", "bathroom", "continence", "eating"];
	orientationSteps = ["time", "space"];
	values = ["1", "2", "3", "4"];
	form: UntypedFormGroup;
	katzScore: string;

	@Input() katz: string;
	@Input() dementia = false;

	@Output() confirm = new EventEmitter<string | undefined>();

	// Declare destroy$ subject locally because extending the OnDestroyComponent here causes circular dependecies
	private readonly destroy$: Subject<void> = new Subject<void>();

	get katzInfo(): { katz: string; dementia: boolean } {
		return {
			katz: this.katzScore,
			dementia: this.dementia,
		};
	}

	save() {
		if (this.form.valid) {
			this.confirm.emit(this.katzScore);
		}
	}

	private patchKATZ() {
		const [washing, clothing, transfer, bathroom, continence, eating, time, space] = this.katz.split("");

		this.form.patchValue({
			washing,
			clothing,
			transfer,
			bathroom,
			continence,
			eating,
			time,
			space,
		});
	}

	private setupForm() {
		this.form = new UntypedFormGroup({});
		for (const step of [...this.baseSteps, ...this.orientationSteps]) {
			this.form.addControl(step, new UntypedFormControl("", Validators.required));
		}
	}

	private mapFormToScore() {
		this.katzScore = [...this.baseSteps, ...this.orientationSteps].map((key) => this.form.get(key).value).join("");
	}

	ngOnInit() {
		this.setupForm();
		if (this.katz) {
			this.patchKATZ();
		}

		this.mapFormToScore();

		this.form.valueChanges.pipe(tap(this.mapFormToScore.bind(this)), takeUntil(this.destroy$)).subscribe();
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
